import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'entry', 'field'];

  connect() {
    this.syncAll();
  }

  toggle(event) {
    const checkbox = event.currentTarget;
    this.syncEntry(checkbox);
  }

  syncAll() {
    this.checkboxTargets.forEach((checkbox) => {
      this.syncEntry(checkbox);
    });
  }

  syncEntry(checkbox) {
    const entryId = checkbox.dataset.entryId;
    const fieldKey = checkbox.dataset.fieldKey;
    const checked = checkbox.checked;

    this.fieldTargets
      .filter((field) => field.dataset.entryId === entryId && field.dataset.fieldKey === fieldKey)
      .forEach((field) => {
        field.classList.toggle('hidden', !checked);
      });

    const entryPanels = this.entryTargets.filter((entry) => entry.dataset.entryId === entryId);
    const hasVisibleFields = this.fieldTargets.some(
      (field) => field.dataset.entryId === entryId && !field.classList.contains('hidden')
    );

    entryPanels.forEach((entry) => {
      entry.classList.toggle('hidden', !hasVisibleFields);
    });
  }
}
